// 定義內容
export default {
	introTitleUIE: 'YAYI-UIE精準的',
	introTitleExtrac: '知識抽取',
	introTitleAI: 'AI助理',
	introTitleMain: '基於百萬級中英雙語料，結合有監督微調與人類意圖對齊，在信息抽取領域表現突出，支持輿情、媒宣、金融、安全等領域複雜場景信息抽取。 ',
	enterkeyword: '輸入關鍵字',
	enterDetail: '進入',
	extractInfor: '抽取資訊',
	extractContent: '抽取內容',
	extractResults: '抽取結果',
	copyJSON: '複製JSON',
	extractionProgress: '正在抽取中',
	sendExtractedView: '左側發送抽取內容後查看',
	record: '記錄',
	historyRecord: '歷史記錄',
	confirmDeletSession: '確認刪除此會話',
	confirm: '確認',
	cancel: '取消',
	submit: '提交',
	nohistory: '暫無歷史記錄',
	feedbackMeansLot: '您的回饋對我們意義重大，希望您填寫您認為',
	moreDesAnswer: '您認為更理想的答案是什麼？ ',
	abnormalNetwork: '目前網絡異常，請檢查網絡',
	copySuccessful: '複製成功',
	likeSuccess: '按讚成功',
	tapSuccess: '點踩成功',
	hisNameNoEmpty: '歷史記錄名稱不能為空',
};
